import { AuthDomain, CookieDomain } from "../types/Domain";
/**
 * Get application by name and environment
 *
 * @param applications
 * @param name
 * @param environment
 * @return {string|undefined} The application
 */
export const getApplicationByNameAndEnvironment = (applications, name, environment) => applications.find((x) => x.name === name && x.environment === environment);
const stageLookup = {
    PLAYGROUND: { cookie: CookieDomain.PLAYGROUND, login: AuthDomain.PLAYGROUND },
    DEV: { cookie: CookieDomain.DEV, login: AuthDomain.DEV },
    STAGING: { cookie: CookieDomain.STAGING, login: AuthDomain.STAGING },
    PROD: { cookie: CookieDomain.PROD, login: AuthDomain.PROD },
    ALL: { cookie: CookieDomain.ALL, login: AuthDomain.PROD },
};
/** Get polestar domain by stage to set cookies.
 *  @param stage
 *  @return {CookieDomain} Polestar domain
 */
export const getCookieDomain = (stage) => {
    const domain = stage ? stageLookup[stage].cookie : CookieDomain.ALL;
    return domain;
};
/** Get polestar domain by stage to link to login url.
 *  @param stage
 *  @return {AuthDomain} Polestar domain
 */
export const getAuthDomain = (stage) => {
    const domain = stage ? stageLookup[stage].login : AuthDomain.PROD;
    return domain;
};
